// Tiny pub/sub so a watch-status write made through ANY code path (not just
// WatchlistContext's own toggle functions — TitleDetail.js, LogModal.js,
// YourTakePanel.js, the Library pages, CatchUp.js, etc. all POST
// /library/status directly) can still tell every open popup/card what the
// real status now is. See api.js's response interceptor (the single place
// that sees every one of those POSTs) and WatchlistContext.js (the
// subscriber) for how this closes the stale-baseline/stale-override gap
// found in iteration 663/664 testing (2026-11-02).
const listeners = new Set();

export function subscribeStatusChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function emitStatusChange(key, status) {
  listeners.forEach((cb) => {
    try { cb(key, status); } catch { /* ignore a bad subscriber */ }
  });
}
